var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuitcaseOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.993,
    height: 32,
    viewBox: "0 0 27.993 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "suitcase_outline",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118002",
    "data-name": "Path 118002",
    d: "M45,43.412V39.882m0,3.529v3.529m0-3.529h9.747a3.4,3.4,0,0,0,3.249-3.529M45,43.412H35.249A3.4,3.4,0,0,1,32,39.882m25.993,0V50.471A3.4,3.4,0,0,1,54.744,54H35.249A3.4,3.4,0,0,1,32,50.471V39.882m25.993,0V32.824a3.4,3.4,0,0,0-3.249-3.529H35.249A3.4,3.4,0,0,0,32,32.824v7.059M49.87,29.294V27.529A3.4,3.4,0,0,0,46.621,24H43.372a3.4,3.4,0,0,0-3.249,3.529v1.765",
    transform: "translate(-32 -24)",
    fill: "none",
    stroke: "#959595",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseOutline);
export default __webpack_public_path__ + "static/media/suitcase_outline.e1c4755fecae1a712f79b11acd02eb24.svg";
export { ForwardRef as ReactComponent };